module.exports = __webpack_public_path__ + "static/media/download_alternative.fae97ab9.svg";